import React, { useState, useImperativeHandle, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Tabs, Tab } from '@mui/material'
import { Colors } from 'Theme'
import { IFTabs } from 'Components'
import ChargingTokenPageTabsSkeleton from './ChargingTokenPageTabsSkeleton'
import { Actions, Subjects } from 'Enums/permissionKeys'

const ChargingTokenPageTabs = React.forwardRef(
  (
    {
      editingAdminRole,
      onValueChange,
      isLoading,
      initialIndex,
      ChargingTokenCount,
      ChargingTokenDesignCount,
      fetchListRequestState,
    },
    ref,
  ) => {
    const canViewDesign = editingAdminRole?.can(
      Actions.VIEW,
      Subjects.CHARGING_TOKENS_DESIGN,
    )
    const canViewTokens = editingAdminRole?.can(
      Actions.VIEW,
      Subjects.CHARGING_TOKENS,
    )

    const tabsToRender = [
      canViewTokens ? ['ChargingTokens', 'Tokens'] : null,
      canViewDesign ? ['ChargingTokenDesigns', 'Designs'] : null,
    ].filter(Boolean)

    const [selectedIndex, setSelectedIndex] = useState(
      tabsToRender.findIndex(
        ([key]) =>
          key ===
          (initialIndex === 1 ? 'ChargingTokenDesigns' : 'ChargingTokens'),
      ),
    )
    useEffect(() => {
      if (canViewTokens && canViewDesign) setSelectedIndex(initialIndex)
    }, [initialIndex])
    const handleChange = (event, newValue) => {
      setSelectedIndex(newValue)
      onValueChange(newValue)
    }

    const resetIndex = () => {
      setSelectedIndex(0)
    }

    useImperativeHandle(ref, () => ({
      resetIndex,
    }))

    return (
      <div>
        {isLoading ? (
          <ChargingTokenPageTabsSkeleton tabsCount={tabsToRender.length} />
        ) : (
          <Tabs
            value={selectedIndex}
            onChange={handleChange}
            TabIndicatorProps={{
              style: {
                backgroundColor: Colors.primary,
              },
            }}
          >
            {tabsToRender.map(([key, title], index) => (
              <Tab
                sx={{
                  padding: '0px',
                  minWidth: 'fit-content',
                  maxWidth: 'fit-content',
                }}
                key={key}
                label={
                  <IFTabs
                    title={title}
                    isSelected={selectedIndex === index}
                    fetchListRequestState={fetchListRequestState}
                    count={
                      key === 'ChargingTokens'
                        ? ChargingTokenCount
                        : ChargingTokenDesignCount
                    }
                  />
                }
              />
            ))}
          </Tabs>
        )}
      </div>
    )
  },
)

ChargingTokenPageTabs.propTypes = {
  editingAdminRole: PropTypes.object,
  onValueChange: PropTypes.func,
  isLoading: PropTypes.bool,
  initialIndex: PropTypes.number,
  ChargingTokenCount: PropTypes.number,
  fetchListRequestState: PropTypes.string,
  ChargingTokenDesignCount: PropTypes.number,
}

export default ChargingTokenPageTabs
